export type FileStructure = 'one-entry-per-row' | 'count-per-entrant';

// Upload status enum - centralized definition
export enum UploadStatus {
  IDLE = 'idle',
  UPLOADING = 'uploading',
  SUCCESS = 'success',
  ERROR = 'error',
  DELETING = 'deleting',
}

// CSV Confirmation Settings - separated from EntriesUpload for clarity
export interface CsvConfirmationSettings {
  isHeaderRow?: boolean;
  fileStructure?: FileStructure;
  uniqueIdColumn?: string; // Required for one-entry-per-row deduplication
  uniqueIdentifierColumns?: string[];
  ticketCountColumn?: string;
  
  // Participant identification column mapping (optional, single-select)
  participantIdentificationColumn?: string; // Single column for winner identification (e.g., full name, participant ID, or defaults to row number)
}

export interface EntriesUpload {
  // Server-side file metadata
  originalFileName?: string;
  storedFileName?: string;
  size?: number;
  mimeType?: string;
  uploadedAt?: string;
  status?: 'uploaded' | 'parsed' | 'failed';
  
  // Parsed CSV data - extracted from server response and flattened for easier access
  rowCount?: number;
  headerRowColumns?: string[];
  entryRow1Columns?: string[];
  entryRow2Columns?: string[];
  
  // Legacy fields - keeping for backward compatibility
  fileId?: string;
  fileName?: string; // Maps to originalFileName
  fileSize?: number; // Maps to size
  
  // Calculated entry count (rowCount - header if present)
  calculatedEntryCount?: number;
}

export interface Prize {
  description: string;
  winners: number;
  reserves: number;
  estimatedValue?: number; // New field for prize value estimation
}

export interface ScrutineerSettings {
  scrutineerRequired?: boolean;
  scrutineerName?: string;
  scrutineerEmail?: string;
  scrutineerJobTitle?: string;
  scrutineerConfirmation?: boolean; // For "I affirm that the scrutineer is present" checkbox
}

export interface DrawData {
  drawId?: string;
  drawName: string;
  organisation: string;
  drawNo?: string;
  entryMethod: 'simple' | 'standard' | 'advanced';
  entryCount?: number;
  uploadedEntries?: EntriesUpload;
  csvConfirmationSettings?: CsvConfirmationSettings;
  prizes: Prize[];
  isDemo: boolean;
  // New scrutineering fields
  totalPrizePoolValue?: number;
  scrutineerSettings?: ScrutineerSettings;
  maxPrizesPerEntrant?: 'one' | 'multiple'; // "one prize each" vs "as many as entries"
  scheduledDateTime?: Date; // Optional scheduled date/time for the draw
  // Payment fields
  paymentIntentId?: string;
  paymentStatus?: 'unpaid' | 'pending' | 'paid' | 'failed';
}